import { createSlice } from '@reduxjs/toolkit'
import { RootState } from "../../store";
import { IPreviewConfig } from "models/preview.model";


export interface PreviewState {
  value: IPreviewConfig | undefined;
}

const initialState: PreviewState = {
  value: undefined,
}

export const previewSlice = createSlice({
  name: 'preview',
  initialState,
  reducers: {
    initPreview: (state, action) => {
      state.value = action.payload
    },
  }
});

export const {initPreview} = previewSlice.actions;
export const previewStoreValue = (state: RootState) => state.preview.value;

export default previewSlice.reducer
